export default {
    bootStrap: 'bstp',
    localeInitialization: 'lcl',
    themeInitialization: 'thm',
    render: 'ren',
};
